import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid } from '@mui/material';

export default function LangageSelect({ setValue, selectedCode, readonly }) {

    const index = countries.findIndex(element => { return (element.code == selectedCode) });

    return (
        <Autocomplete
            size="small"
            id="country-select-demo"
            value={countries[index] || null}
            options={countries}
            getOptionLabel={(option) => option.name}
            style={{ minWidth: '100%', borderRadius: '30px' }}
            onChange={(event, newInputValue) => {
                setValue(newInputValue.code);
            }}
            renderOption={(props, option) => (
                <Box  {...props} >
                    <Grid container spacing={1}>

                        <Grid item xs={10}>
                            {option.name}
                        </Grid>
                    </Grid>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className='form-control'
                    disabled={readonly}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />
    );
}


const countries = [
    { code: 'AR', name: 'Arabic' },
    { code: 'BN', name: 'Bengali' },
    { code: 'BS', name: 'Bosnian' },
    { code: 'BG', name: 'Bulgarian' },
    { code: 'CA', name: 'Catalan' },
    { code: 'CS', name: 'Czech' },
    { code: 'DA', name: 'Danish' },
    { code: 'DE', name: 'German' },
    { code: 'ET', name: 'Estonian' },
    { code: 'EL', name: 'Greek' },
    { code: 'EN', name: 'English' },
    { code: 'ES', name: 'Spanish' },
    { code: 'FI', name: 'Finnish' },
    { code: 'FR', name: 'French' },
    { code: 'GA', name: 'Irish' },
    { code: 'HE', name: 'Hebrew' },
    { code: 'HI', name: 'Hindi' },
    { code: 'HU', name: 'Hungarian' },
    { code: 'ID', name: 'Indonesian' },
    { code: 'IT', name: 'Italian' },
    { code: 'JA', name: 'Japanese' },
    { code: 'JV', name: 'Javanese' },
    { code: 'KA', name: 'Georgian' },
    { code: 'KO', name: 'Korean' },
    { code: 'KN', name: 'Kannada' },
    { code: 'LT', name: 'Lithuanian' },
    { code: 'LV', name: 'Latvian' },
    { code: 'ML', name: 'Malayalam' },
    { code: 'MN', name: 'Mongolian' },
    { code: 'MK', name: 'Macedonian' },
    { code: 'MR', name: 'Marathi' },
    { code: 'NO', name: 'Norwegian' },
    { code: 'PL', name: 'Polish' },
    { code: 'PT', name: 'Portuguese' },
    { code: 'PA', name: 'Punjabi' },
    { code: 'RO', name: 'Romanian' },
    { code: 'RU', name: 'Russian' },
    { code: 'SR', name: 'Serbian' },
    { code: 'SQ', name: 'Albanian' },
    { code: 'SK', name: 'Slovak' },
    { code: 'SL', name: 'Slovenian' },
    { code: 'SW', name: 'Swahili' },
    { code: 'TA', name: 'Tamil' },
    { code: 'TE', name: 'Telugu' },
    { code: 'TH', name: 'Thai' },
    { code: 'TR', name: 'Turkish' },
    { code: 'UK', name: 'Ukrainian' },
    { code: 'VI', name: 'Vietnamese' },
    { code: 'ZH-CN', name: 'Chinese (Simplified)' }
]